export { FormationCardGlow as default } from '@/components/ui/formation-card-glow';
